import { useScrollResetter } from 'packages/smart-home-support/hooks';
import { RouteComponent } from 'packages/smart-home-support/routes/models';
import { composePage, withFooterConfig, withHeaderConfig } from 'packages/smart-home-support/routes/utils';
import React, { useState } from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';

import { PATHS, PageId } from '../../constants';
import NotFoundPage from '../notfound';
import ConfirmPage from './ConfirmPage';
import LoginPage from './LoginPage';
import LogoutPage from './LogoutPage';
import { AuthPageProps, AuthPath } from './models';
import { getPath, getTo } from './utils';
import { PageConfig } from '../../models';

const composeAuthPage = (pageConfig: PageConfig, ...fns: Array<Function>) =>
  composePage(
    pageConfig,
    ...fns,
    withHeaderConfig({ isNavigable: false, isLogoLinked: false }),
    withFooterConfig({ type: 'minimal' })
  );

const routes: Array<RouteComponent> = [
  {
    Component: composeAuthPage({ pageId: PageId.VerifySecretCode })(ConfirmPage),
    route: { exact: true, path: getPath(AuthPath.Confirm) },
  },
  {
    Component: composeAuthPage({ pageId: PageId.Login })(LoginPage),
    route: { exact: true, path: getPath(AuthPath.Login) },
  },
  {
    Component: composeAuthPage({ pageId: PageId.Logout })(LogoutPage),
    route: { exact: true, path: getPath(AuthPath.Logout) },
  },
];

const AuthPages: React.FC<AuthPageProps & RouteComponentProps & { isEnabled: boolean }> = (props) => {
  const [password, setPassword] = useState('');
  const [mdn, setMdn] = useState('');
  const pageProps = {
    ...props,
    password,
    setPassword,
    mdn,
    setMdn,
  };

  useScrollResetter([props.location]);

  return !props.isEnabled ? (
    <NotFoundPage />
  ) : (
    <Switch>
      {routes.map(({ route, Component }, i) => (
        <Route
          {...route}
          key={i}
          render={() => (
            <>
              <Component {...pageProps} />
            </>
          )}
        />
      ))}
      <Route exact path={`/${PATHS.auth}`}>
        <Redirect to={getTo(AuthPath.Login)} />
      </Route>
    </Switch>
  );
};

export default AuthPages;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/index.tsx